import { render, staticRenderFns } from "./assets-tree.vue?vue&type=template&id=161f4160&"
import script from "./assets-tree.vue?vue&type=script&lang=js&"
export * from "./assets-tree.vue?vue&type=script&lang=js&"
import style0 from "./assets-tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports